import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { colors, typography, spacing, borderRadius } from "./theme";

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.main,
    },
  },
  typography: {
    fontFamily: typography.fontFamily.primary,
    fontSize: typography.fontSize.base,
  },
  components: {
     MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.paper,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.medium,
          textTransform:'none',
          '&.MuiButton-containedPrimary': {
            backgroundColor: colors.primary.main,
            '&:hover': {
              backgroundColor: colors.primary.hover,
            },
          },
          '&.Mui-disabled': {
            backgroundColor: colors.button.disabled,
            color: 'white',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 30,
          height: 20,
          padding: 0,
          display: "flex",
        },
        switchBase: {
          padding: 2,
          '&.Mui-checked': {
            transform: "translateX(10px)",
            color: "#fff",
            '& + .MuiSwitch-track': {
              backgroundColor: colors.switch.checked,
              opacity: 1,
            },
          },
        },
        thumb: {
          width: 16,
          height: 16,
          boxShadow: "none",
        },
        track: {
          borderRadius: 13,
          backgroundColor: colors.switch.track,
          opacity: 1,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root:{
          marginLeft: spacing.sm,
          gap: `${spacing.md}px`,  
        },
        label: {
          fontFamily: typography.fontFamily.primary,
          fontSize: `${typography.fontSize.large}px`,
          fontWeight: typography.fontWeight.medium,
          fontStyle: "normal",
          lineHeight: typography.lineHeight.normal,
          color: colors.text.primary,
          textTransform: "none",
          letterSpacing: typography.letterSpacing.wide,
        },
      },
    },
  },
});

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <MsalProvider instance={msalInstance}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
